<template>
  <div class="top-padding">
    <div class="uk-navbar-container" uk-navbar
         v-if="(statusFlags.pending || statusFlags.approved || statusFlags.declined)">
      <div class="uk-navbar-left">
        <div :class="{'title-container': !mod, 'moderation-title-container': mod}">
          <a class="title-text" v-if="mod">{{$t('actionsBar.resourceModeration')}}</a>
          <a class="title-text" v-else>{{$t('actionsBar.myResource')}}</a>
        </div>
        <div
          :class="{'approved': statusFlags.approved, 'pending': statusFlags.pending, 'declined': statusFlags.declined}"
          class="divider">
        </div>
        <div class="bar-text" v-if="statusFlags.approved">{{$t('actionsBar.publiclyShared')}}</div>
        <div class="bar-text" v-if="statusFlags.pending">{{$t('actionsBar.pendingApproval')}}
          <a @click="openUrl(resourceGuide)"
             class="link"
             v-if="!mod">{{$t('general.learnMore')}}</a>
        </div>
        <div class="bar-text" v-if="statusFlags.declined">
          <img v-if="!mod" :src="warningIcon">{{$t('actionsBar.declined')}}
            <a v-if="declineReasons" uk-toggle="target: #declined-info-modal" class="link">
              {{$t('modals.declinedResource.whyWasTheResourceDeclined')}}</a>
            <a v-if="!mod" @click="openUrl(resourceGuide)" class="link">
              {{$t('actionsBar.howDoIFixThis')}}</a>
        </div>
      </div>
      <div class="uk-navbar-center">
        <div class="language-label-container">
          <span v-if="mod && language && getDetails()" class="language-label">{{language}}</span>
        </div>
      </div>
      <div class="uk-navbar-right">
        <div class="back-nav" v-if="mod">
          <a @click="goBack()"> < {{$t('actionsBar.backToQueue')}}</a>
        </div>
        <div v-if="!statusFlags.declined" class="edit-container">
          <button @click="edit()" v-if="!mod">{{$t('general.edit')}}</button>
          <button @click="approve()" v-else>{{$t('general.approve')}}</button>
        </div>
        <div class="delete-container">
          <button uk-toggle="target: #delete-modal" v-if="!mod">{{$t('general.delete')}}</button>
          <button v-else-if="!statusFlags.declined" uk-toggle="target: #decline-modal">{{$t('general.decline')}}
          </button>
        </div>
      </div>
    </div>
    <delete-modal :heading="$t('actionsBar.deleteResource')" id="delete-modal" v-on:delete-resource="deleteCall()"></delete-modal>
    <decline-modal id="decline-modal" v-on:decline-resource="decline"></decline-modal>
    <declined-info-modal :declineReasons="declineReasons" :declineInfo="declineInfo"></declined-info-modal>
    <resource-removed @leave-page="leave"></resource-removed>
  </div>
</template>

<script>
  import Router from '../../../../router/index'
  import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
  import deleteModal from '../../../ui-components/modals/delete-modal'
  import declineModal from '../../../ui-components/modals/decline-resource'
  import * as misc from '../../../../enums/misc'
  import * as moderationStatus from '../../../../enums/moderation-status'
  import iconUtil from '../../../../utils/icon-util'
  import * as url from '../../../../enums/static-urls'
  import * as routes from '../../../../enums/routes'
  import * as languageCode from '../../../../enums/supported-languages'
  import * as event from '../../../../enums/mixpanel-event'
  import mixpanel from '../../../../services/mixpanel'
  import UIkit from 'uikit'
  import ResourceRemoved from '../../../ui-components/modals/resource-removed'
  import declinedInfoModal from '../../../ui-components/modals/declined-info'

  export default {
    name: 'actions-bar',
    props: ['mod'],
    components: {
      ResourceRemoved,
      deleteModal,
      declineModal,
      declinedInfoModal
    },
    data() {
      return {
        route_MyResource: routes.ROUTE_NAME_MYRESOURCE,
        route_ModerateResource: routes.ROUTE_NAME_MODERATE_RESOURCE,
        APPROVED: moderationStatus.APPROVED,
        PENDING: moderationStatus.PENDING,
        DECLINED: moderationStatus.DECLINED,
        statusFlags: {
          approved: false,
          declined: false,
          pending: false
        },
        warningIcon: iconUtil.resolve(misc.WARNING_RED_ICON),
        resourceGuide: url.RESOURCE_GUIDE,
        next: null,
        moderationStatus: '',
        loading: false,
        supportedLanguages: [],
        resourceRemovedError: 'NOT_FOUND',
        declineReasons: null,
        declineInfo: null
      }
    },
    computed: {
      ...mapGetters(['getDetails', 'getPendingResourcesQueue', 'getDeclinedResourcesQueue', 'getDeclinedQueueLoading']),
      ...mapState(['moderation']),
      language() {
        if (this.getDetails().detail && this.getDetails().contentId === this.$route.params.id) {
          if (this.getDetails().detail.language) {
            let title = languageCode.SUPPORTED_LANGUAGES.find(o => o.ID === this.getDetails().detail.language).title
            return this.$t('languages')[title]
          }
        } else {
          return null
        }
      }
    },
    watch: {
      moderation: {
        deep: true,
        handler() {
          if (this.moderation.resources.queues.loading) {
            this.loading = true
          } else {
            this.loading = false
          }
          if (this.moderation.resources.queues.items.find(k => k.contentId === this.$route.params.id)) {
            let resource = this.moderation.resources.queues.items.find(k => k.contentId === this.$route.params.id)
            this.moderationStatus = resource.status
            this.setModeratedQueuesLoadingStatus({loading: false})
            this.setStatusFlags()
            if (!this.declineReasons) {
              if (resource.declineReasons || resource.declineInfo) {
                this.setDeclinedData(resource.declineReasons, resource.declineInfo)
                this.showDeclinedInfoModal()
              }
            }
          }
        }
      },
      '$route.params.id': function () {
        if (this.mod) {
          this.getResourceModerationStatus({contentId: this.$route.params.id})
            .then(result => {
              this.populateStatus(result.status)
              this.setDeclinedData(result.declineReasons, result.declineInfo)
            })
        } else {
          this.getResourceStatus({contentId: this.$route.params.id})
            .then(result => {
              this.populateStatus(result.status)
            })
        }
      }
    },
    methods: {
      ...mapActions(['deleteResource', 'changeResourceState', 'fetchModerationQue', 'getResourceStatus', 'getResourceModerationStatus', 'resolveStrandData']),
      ...mapMutations(['setModeratedQueuesLoadingStatus', 'setModerationQueuesLoadingStatus']),
      populateStatus(result) {
        if (result) {
          this.moderationStatus = result
          this.setStatusFlags()
          if (!this.mod) {
            this.setModeratedQueuesLoadingStatus({loading: false})
          }
        }
      },
      edit() {
        this.content = this.getDetails()
        let strands = []
        if (this.content.detail.standardStrands) {
          this.resolveStrandData(this.content.detail.standardStrands)
              .then(response => {
                for (let strand of response) {
                  let strandObj = {title: strand.body.standard_number + '  ' + strand.body.standard_text, guid: strand.body.guid, standard: strand.body.standard_number, description: strand.body.standard_text}
                  strands.push(strandObj)
                }
                let resource = {
                  id: this.content.contentId,
                  title: this.content.detail.title,
                  description: this.content.detail.description,
                  keywords: this.content.detail.tags,
                  grades: this.content.detail.grades,
                  subjects: this.content.detail.subjects,
                  resourceTypes: this.content.detail.componentTypes,
                  country: this.content.detail.country,
                  language: this.content.detail.language,
                  standardSets: this.content.detail.standardSets,
                  standardStrands: strands
                }
                Router.push({name: 'ShareResource', params: {metadata: resource}})
              })
        } else {
          let resource = {
            id: this.content.contentId,
            title: this.content.detail.title,
            description: this.content.detail.description,
            keywords: this.content.detail.tags,
            grades: this.content.detail.grades,
            subjects: this.content.detail.subjects,
            resourceTypes: this.content.detail.componentTypes,
            country: this.content.detail.country,
            language: this.content.detail.language
          }
          Router.push({name: 'ShareResource', params: {metadata: resource}})
        }
      },
      deleteCall() {
        this.content = this.getDetails()
        this.deleteResource(this.content.contentId)
          .then(() => {
            mixpanel.track(event.FILE_DELETED)
            Router.push({
              path: '/manage-my-resources/'
            })
          })
      },
      goBack() {
        Router.push({
          path: '/moderate-resources/'
        })
      },
      approve() {
        this.content = this.getDetails()
        this.changeResourceState({
          contentId: this.content.contentId,
          status: this.APPROVED,
          moderation: this.mod
        })
          .then((next) => {
            this.handleNavigation(next)
          })
          .catch(error => {
            if (error.response.body.message === this.resourceRemovedError) {
              this.resourceRemoved()
            }
          })
      },
      handleNavigation(resource) {
        if (resource === null || resource === undefined) {  // there are no more resources in the queue so go back to the moderate resources route
          Router.push({
            path: `/${routes.MODERATE_RESOURCES_PATH}/`
          })
        } else { // there is another resource to moderate
          Router.push({
            path: `/${routes.MODERATE_RESOURCE_PATH}/` + resource.contentId
          })
        }
      },
      decline(declineInfo) {
        this.content = this.getDetails()
        this.changeResourceState({
          contentId: this.content.contentId,
          status: this.DECLINED,
          moderation: this.mod,
          declineInfo: declineInfo.message,
          declineReasons: declineInfo.reasons
        })
          .then((next) => {
            if (next) {
              Router.push({
                path: '/moderate-resource/' + next.contentId
              })
            } else {
              Router.push({
                path: `/${routes.MODERATE_RESOURCES_PATH}/`
              })
            }
          })
          .catch(error => {
            if (error.response.body.message === this.resourceRemovedError) {
              this.resourceRemoved()
            }
          })
      },
      setStatusFlags() {
        switch (this.moderationStatus) {
          case this.APPROVED.toUpperCase():
            this.statusFlags.approved = true
            this.statusFlags.pending = false
            this.statusFlags.declined = false
            break
          case this.PENDING.toUpperCase():
            this.statusFlags.pending = true
            this.statusFlags.approved = false
            this.statusFlags.declined = false
            break
          case this.DECLINED.toUpperCase():
            this.statusFlags.declined = true
            this.statusFlags.approved = false
            this.statusFlags.pending = false
        }
      },
      resourceRemoved() {
        UIkit.modal('#resource-removed').show()
      },
      showDeclinedInfoModal() {
        UIkit.modal('#declined-info-modal').show()
      },
      leave() {
        Router.push({
          path: `/${routes.MODERATE_RESOURCES_PATH}/`
        })
      },
      openUrl(url) {
        window.open(url, '_blank')
      },
      setDeclinedData(reasons, info) {
        this.declineReasons = reasons
        this.declineInfo = info
      }
    },
    created() {
      if (this.mod) {
        this.getResourceModerationStatus({contentId: this.$route.params.id})
          .then(result => {
            this.populateStatus(result.status)
            this.setDeclinedData(result.declineReasons, result.declineInfo)
          })
      } else {
        this.getResourceStatus({contentId: this.$route.params.id})
          .then(result => {
            this.populateStatus(result.status)
            if (result.declineReasons || result.declineInfo) {
              this.setDeclinedData(result.declineReasons, result.declineInfo)
              this.showDeclinedInfoModal()
            }
          })
      }
    }
  }
</script>
<style lang='scss' scoped>
  @import '../../../../styles/colours';
  @import '../../../../styles/breakpoints';

  .language-label {
    font-size: 18px;
    color: $content-text;
  }

  .language-label-container {
    width: auto;
    height: 20px;
  }

  .back-nav {
    font-size: 18px;
    font-weight: bold;
    padding-right: 31px;
    color: $content-link-blue;
  }

  img {
    padding-right: 12px;
  }

  .bar-text {
    padding-left: 24px;
    font-size: 18px;
  }

  .link {
    color: $content-link-blue;
    font-weight: bold;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .uk-navbar-container {
    min-height: 56px;
    width: 100%;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
  }

  .moderation-title-container {
    width: 258px;
    padding: 0 0 0 24px;
  }

  .title-container {
    min-width: 166px;
    padding: 0 24px;
  }

  .title-text {
    font-size: 20px;
    font-weight: bold;
    color: $content-text;
    text-decoration: none;
    font-bold: normal;
    color: $content-text;
  }

  .divider {
    width: 8px;
    height: 56px;
  }

  .approved {
    background-color: $approved-indicator;
  }

  .declined {
    background-color: $input-warning;
  }

  .pending {
    background-color: $warning-orange;
  }

  button {
    min-width: 125px;
    height: 40px;
  }

  .edit-container {
    padding: 0 8px 0 0;

    button {
      border-radius: 2px;
      border: solid 2px $light-blue;
      font-size: 18px;
      font-weight: bold;
      color: white;
      background-color: $light-blue;

      &:hover {
        border-radius: 2px;
        box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
        border: solid 2.8px white;
        background-color: white;
        color: $light-blue;
      }
    }
  }


  .delete-container {
    padding: 0 24px 0 0;

    button {
      color: white;
      background-color: $input-warning;
      border-radius: 2px;
      box-shadow: 0 1px 3px 0 $drop-shadow-black;
      border: solid 2.8px $input-warning;
      font-size: 18px;
      font-weight: bold;

      &:hover {
        box-shadow: 3px 5px 8px 0 $drop-shadow-black;
        border: solid 2.8px white;
        background-color: white;
        color: $input-warning;
      }
    }
  }

  .top-padding {
    padding: 56px 0 0 0;
  }

  @media screen and (max-width: ($breakpoint-medium - 1)) {
    .top-padding {
      padding: 104px 0 0 0;
    }

    .bar-text {
      padding-left: 16px;
      font-size: 16px;
    }
  }

  @media screen and (min-width: ($breakpoint-medium)) and (max-width: $breakpoint-medium) {
    .top-padding {
      padding: 48px 0 0 0;
    }
  }
</style>
